import { render, staticRenderFns } from "./whiteIdNumber.vue?vue&type=template&id=4ef9364c&"
import script from "./whiteIdNumber.vue?vue&type=script&lang=js&"
export * from "./whiteIdNumber.vue?vue&type=script&lang=js&"
import style0 from "./whiteIdNumber.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports